import React from "react";
import { FrontColors } from "../../../../models/FrontColors";
import { FrontFontSizes } from "../../../../models/FrontFontSizes";
import { FrontSpacing } from "../../../../models/FrontSpacing";
import { Background } from "../../../BuildingBlocks/Background";
import { UnstyledInputDateComponent } from "../../../UnstyledInputDateComponent/UnstyledInputDateComponent";
import { FrontIcon } from "../../../Front/Simple/FrontIcon/FrontIcon";

export const FPInputDate = (props: React.PropsWithChildren<{
    coloursInverted?: boolean;
    flatEdge?: boolean;
    value: string;
    placeholder?: string;
    autoFocus?: boolean;
    displayError?: boolean;
    onChange: (value: string) => void;
    onEnter: () => void;
}>): JSX.Element => {
    const coloursInverted = props.coloursInverted || false;

    const flatEdge = props.flatEdge || false;

    const placeholder = props.placeholder || undefined;

    const displayError = props.displayError || false;

    const inputBackgroundColour =
        coloursInverted
            ? FrontColors.NEUTRAL_18
            : FrontColors.PROBATE_0;

    const borderColour =
        coloursInverted
            ? FrontColors.NEUTRAL_18
            : FrontColors.PROBATE_0;

    const inputDateTextColour =
        displayError ? FrontColors.ERROR_FIREBRICK_10
        : coloursInverted ? FrontColors.NEUTRAL_0
        : FrontColors.NEUTRAL_13;

    const borderRadius =
        flatEdge
            ? "5px 0px 0px 5px"
            : "5px";

    return <Background
        display="flex"
        borderRadius={borderRadius}
        borderDefinition={`solid 2px ${borderColour}`}
        color={inputBackgroundColour}
        height="100%"
        minHeight="48px"
        padding={`0px ${FrontSpacing.SMALL_3}`}
        alignItems="center"
    >
        <UnstyledInputDateComponent
            dateType="date"
            value={props.value}
            displayError={false}
            autoFocus={props.autoFocus || false}
            placeholder={placeholder}
            className={`fs-exclude front-probate-input-date__input-date ${
                displayError ? "front-probate-input-date__input-date--error"
                : coloursInverted ? "front-probate-input-date__input-date--inverted"
                : ""
            }`}
            style={{
                width: "100%",
                height: "100%",
                WebkitAppearance: "none",
                appearance: "none",
                background: "none",
                outline: "none",
                border: "none",
                fontSize: FrontFontSizes.SMALL,
                fontFamily: "Roboto Slab",
                color: inputDateTextColour,
            }}
            onChange={props.onChange}
            onPressEnterKey={props.onEnter}
        />

        {/* The field is a text input until it is focused, so the browser's own
            indicator is absent exactly when the reader needs the clue that this is a
            date. This one does not move. */}
        <FrontIcon
            iconName="clock"
            colour={inputDateTextColour}
            size="tiny"
        />
    </Background>;
};

